/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Stamps_Work_List3Inputs */

const en_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stamps can only be used during this event.`)
};

const ar_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكن استخدام الطوابع خلال هذا الحدث فقط.`)
};

const de_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stempel können nur während dieses Events verwendet werden.`)
};

const es_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los sellos solo se pueden usar durante este evento.`)
};

const fr_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les timbres ne peuvent être utilisés que pendant cet événement.`)
};

const it_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I timbri possono essere utilizzati solo durante questo evento.`)
};

const ja_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプは本イベント期間中のみ使用できます。`)
};

const ko_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프는 이번 이벤트 기간 동안에만 사용할 수 있습니다.`)
};

const pt_br_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os selos só podem ser usados durante este evento.`)
};

const ru_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Штампы можно использовать только во время этого события.`)
};

const th_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สามารถใช้แสตมป์ได้ในช่วงเวลากิจกรรมนี้เท่านั้น`)
};

const tr_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pullar yalnızca bu etkinlik sırasında kullanılabilir.`)
};

const zh_cn_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花仅限于本次活动期间使用。`)
};

const zh_tw_how_stamps_work_list3 = /** @type {(inputs: How_Stamps_Work_List3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花僅限於本次活動期間使用。`)
};

/**
* | output |
* | --- |
* | "Stamps can only be used during this event." |
*
* @param {How_Stamps_Work_List3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_stamps_work_list3 = /** @type {((inputs?: How_Stamps_Work_List3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Stamps_Work_List3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_stamps_work_list3(inputs)
	if (locale === "ar") return ar_how_stamps_work_list3(inputs)
	if (locale === "de") return de_how_stamps_work_list3(inputs)
	if (locale === "es") return es_how_stamps_work_list3(inputs)
	if (locale === "fr") return fr_how_stamps_work_list3(inputs)
	if (locale === "it") return it_how_stamps_work_list3(inputs)
	if (locale === "ja") return ja_how_stamps_work_list3(inputs)
	if (locale === "ko") return ko_how_stamps_work_list3(inputs)
	if (locale === "pt_br") return pt_br_how_stamps_work_list3(inputs)
	if (locale === "ru") return ru_how_stamps_work_list3(inputs)
	if (locale === "th") return th_how_stamps_work_list3(inputs)
	if (locale === "tr") return tr_how_stamps_work_list3(inputs)
	if (locale === "zh_cn") return zh_cn_how_stamps_work_list3(inputs)
	return zh_tw_how_stamps_work_list3(inputs)
});